import React, { useEffect, useState } from 'react'
import facebookIcon from "../images/facebookIcon.png";
import twitterIcon from "../images/twitterIcon.png";
import instagramIcon from "../images/instagramIcon.png";
import appIcon1 from "../images/appIcon1.png";
import appIcon2 from "../images/appIcon2.png";
import mobileIcon from "../images/mobileIcon.png";
import appStoreIcon from "../images/appStoreIcon.png";
import gplayIcon from "../images/gplayIcon.png";
import { Link } from 'react-router-dom';
import { sitePolicy } from '../asiosConfig';
import logo from "../images/logo.png";



function Footer() {
    const [footer, setFooter] = useState({});
    useEffect(() => {
        const fetchFooter = async () => {
            try {
                const response = await sitePolicy();
                if (response.status === 200 || response.status === 201) {
                    setFooter(response.data.data);
                }
            } catch (error) {
                console.log("Something went wrong");

            }
        }
        fetchFooter();
    }, []);
    return (
        <>
            <div className="footerBlock">
                <div className="container">
                    <div className="row">
                        <div className="col-md-3 col-6" style={{ textAlign: 'left' }}>
                            <p></p>
                            <img src={logo} alt='Ind logo'/>
                            <p></p>
                            <p>One of India’s top matrimonial platforms, helping lakhs find their perfect life partner.</p>
                        </div>
                        <div className="col-md-1 col-6"></div>
                        <div className="col-md-3 col-6">
                            <div className="footerLink" style={{ textAlign: 'left' }}>
                                <h5>Explore</h5>
                                <p><Link to="/">Home</Link></p>
                                {/* <p><a href="advancedsearch.html">Advanced Search</a></p> */}
                                <p><Link to="/success-story">Success stories</Link></p>
                                <p><Link to="/center">indmatrimony centers</Link></p>
                                <p><Link to="/contact-us">Contact Us</Link></p>
                                {/* <p><a href="sitemap.html">Sitemap</a></p> */}
                            </div>
                        </div>

                        {/* <div className="col-md-3 col-6">
                            <div className="footerLink" style={{ textAlign: 'left' }}>
                                <h5>Services</h5>
                                <p><Link to="/upgrades">Membership Options</Link></p>
                                <p><a href="careers.html">Careers</a></p>
                            </div>
                        </div>
                        <div className="col-md-3 col-6">
                            <div className="footerLink" style={{ textAlign: 'left' }}>
                                <h5>Help</h5>
                                <p><Link to="/contact-us">Contact Us</Link></p>
                                <p><Link to="/center">indmatrimony centers</Link></p>
                            </div>
                        </div> */}
                        <div className="col-md-3 col-6">
                            <div className="footerLink" style={{ textAlign: 'left' }}>
                                <h5>Legal</h5>
                                <p><Link to="/about-us">About us</Link></p>
                                <p><Link to="/fraud-alert">Fraud Alert</Link></p>
                                <p><Link to="/term-of-uses">Terms of use</Link></p>
                                <p><Link to="/cancellation-refund">Cancellation and Refund</Link></p>
                                <p><Link to="/privacy-policy">Privacy policy</Link></p>
                                {/* <p><Link to="/privacy-feature">Privacy Features</Link></p> */}
                                <p><Link to="/cookie-policy"> Cookie policy</Link></p>
                                <p><Link to="/grievances">Grievances</Link></p>
                                <p><Link to="/child-policy">Child Safety policy </Link></p>
                            </div>
                        </div>
                        <div className="col-md-2 col-6">
                            <div className="footerLink">
                                <h5>App available on</h5>
                                <p>
                                    <a href="https://apps.apple.com/in/app/ind-matrimony/id6741297825"><img src={appStoreIcon}  style={{width:'49%'}} alt="app img" /></a>
                                    <a href="https://play.google.com/store/apps/details?id=com.indmatrimony.ind_matrimony"><img src={gplayIcon} style={{width:'51%'}} alt="app img" /></a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="footerEnd text-center">
                <div className="container">
                    <div className="row justify-content-between align-items-between">
                        <div className="col-lg-4 col-md-4 col-sm-12">
                            <div className="endSec">
                                <a href={footer?.fb_link} target="_blank" rel="noopener noreferrer">
                                    <img src={facebookIcon} alt="facebook img" />
                                </a>&nbsp;
                                <a href={footer?.twitter_link} target="_blank" rel="noopener noreferrer">
                                    <img src={twitterIcon} alt="twitter img" />
                                </a>&nbsp;
                                <a href={footer?.insta_link} target="_blank" rel="noopener noreferrer">
                                    <img src={instagramIcon} alt="instagram img" />
                                </a>

                            </div>
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-12">
                            <div className="endSec">
                                <p className="copyrightTxt" style={{ whiteSpace: "nowrap" }}>{footer?.footer_txt}</p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-12">
                            <div className="endSec">
                                <p className="copyrightTxt"> <img src={mobileIcon} /> {footer?.phoneNumber}</p>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </>

    )
}

export default Footer
